import { QueryClient } from '@tanstack/react-query';

/**
 * Create a configured QueryClient instance
 * Settings are optimized for a chat/conversation application
 */
export const createQueryClient = () =>
	new QueryClient({
		defaultOptions: {
			queries: {
				staleTime: 60 * 1000, // 1 minute
				gcTime: 5 * 60 * 1000, // 5 minutes
				retry: 2,
				refetchOnWindowFocus: false // Disable for chat app - we control refetches
			},
			mutations: {
				retry: 1
			}
		}
	});
